import { Box, useBoolean } from '@chakra-ui/react';
import React from 'react';
import FileViewer from '../../../components/pdf_viewer/FileViewer';
import { SheetEyeIcon } from '../../../constants/IconData';
import { useAuditReportAttachment } from '../../../components/pdf_viewer/AuditReportViewer';
import { getDocumentViewerPath } from '../../../components/pdf_viewer/documentViewer.utils';

const AuditSheetFileViewer = ({ 
  auditData, 
  icon, 
  chart_id=null,
  onOpen = () => {},
  onClose = () => {}
}) => {
  const [isFileOpen, ifoState] = useBoolean(false);
  const resourceId = auditData?.id || chart_id;
  // Client-specific: chart_id may arrive as a non-string (e.g. number); temp fix until data is normalized upstream
  const isTocChart = typeof chart_id === 'string' && chart_id.startsWith('TOC');
  const { attachment } = useAuditReportAttachment({
    chartId: isFileOpen && isTocChart ? chart_id : undefined,
  });
  const handleOpen = () => {
    onOpen();
    ifoState.on();
  };

  return (
    <React.Fragment>
      {icon ? <Box onClick={handleOpen}
        style={{
          width: 40,
          height: 40,
          cursor: 'pointer',
          display: 'inline-block',
        }}> {icon}</Box> : <SheetEyeIcon
        onClick={handleOpen}
        style={{
          width: 40,
          height: 40,
          cursor: 'pointer',
          display: 'inline-block',
        }}
      />}
      <FileViewer
        isOpen={isFileOpen}
        currentFile={auditData?.file_obj}
        attachments={[
          ...(auditData?.attachments || []),
          ...(isTocChart && attachment ? [attachment] : [])
        ]}
        viewerPath={getDocumentViewerPath({ chartId: resourceId })}
        chartId={auditData?.upload_id || auditData?.file_id || resourceId}
        onClose={() => {
          onClose();
          ifoState.off();
        }}
      />
    </React.Fragment>
  );
};

export default AuditSheetFileViewer;
